import React from "react";

// Types
import InstanaSnapshot from "../../types/integration/InstanaSnapshot";


// Components.
import CopyUrl from "../../component/buttons/CopyUrl";
import ConditionalRender from "../../helpers/ConditionalRender";
import InstanaInstanceButton from "../../component/buttons/InstanaInstanceButton";
import RefreshButton from "../../component/buttons/RefreshButton";
import FilterListButton from "../../component/FilterListButton";
import FilterSaveButton from "../../component/FilterSaveButton";
import PeriodSelector from "../../component/PeriodSelector";
import ThirdPartyLinks from "../../component/buttons/ThirdPartyLinks";
import EditButton from "../../component/buttons/Edit";

// Style
import './style.scss'

type HeaderActionsProps = {
    toggleMenu: Function,
    refresh?: () => void,
    applyPeriod?: Function,
    setFilterOptions?: Function,
    instanaSnapshots?: InstanaSnapshot[]
}

const HeaderActions = (props: HeaderActionsProps) => {
    const url = window.location.pathname
    const instancePattern = /^\/instances\/(\d+)\/([A-Za-z0-9-]+)$/;
    const hostPattern = /^\/hosts\/(\d+)(?:\/([A-Za-z0-9-]+))?$/;
    const match = url.match(instancePattern || hostPattern);
    const id = match ? parseInt(match[1]) : null
    return <React.Fragment>
        {/* Added ms-auto to push the column to the right within the parent row */}
        <div className="col col-lg-5 col-md-6 col-sm-6 order-last icon text-md-end actions ms-auto">
            {instancePattern.test(window.location.pathname) || hostPattern.test(window.location.pathname) ?
                <EditButton type={window.location.pathname.split("/")[1]} id={window.location.pathname.split("/")[2]}/> : ''}
            <CopyUrl/>
            {instancePattern.test(window.location.pathname) && id ? <ThirdPartyLinks instanceId={id}/> : ''}

            <ConditionalRender if={props.instanaSnapshots}>
                <InstanaInstanceButton instanaSnapshots={props.instanaSnapshots || []}/>
            </ConditionalRender>

            <ConditionalRender if={props.refresh}>
                <RefreshButton refresh={props.refresh || (() => {})}/>
            </ConditionalRender>

            <ConditionalRender if={props.applyPeriod}>
                <FilterListButton applyPeriod={props.applyPeriod || (() => {})} setFilterOptions={props.setFilterOptions}/>
                <FilterSaveButton/>
                <PeriodSelector applyPeriod={props.applyPeriod || (() => {})}/>
            </ConditionalRender>

            <button type="button" className="btn btn-heading d-none"><i className="fal fa-play fa-fw"/></button>

            <button type="button" className="btn btn-heading btn-menu d-1200-none" onClick={() => props.toggleMenu()}><i
                className="fal fa-bars fa-fw"/></button>
        </div>
    </React.Fragment>
};


export default HeaderActions;
